import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import type { ChartDataPoint, ChartSeries } from './types';
import { CHART_COLOR_PALETTE } from './types';

interface AreaChartProps {
  data: ChartDataPoint[];
  series?: ChartSeries[];
  dataKey?: string;
  xAxisKey?: string;
  height?: number;
  showGrid?: boolean;
  showLegend?: boolean;
  stacked?: boolean;
  fillOpacity?: number;
}

export default function AreaChart({
  data,
  series,
  dataKey = 'value',
  xAxisKey = 'name',
  height = 280,
  showGrid = true,
  showLegend = false,
  stacked = false,
  fillOpacity = 0.3,
}: AreaChartProps) {
  // If no series provided, create a default one
  const chartSeries = series || [
    { dataKey, name: dataKey, color: CHART_COLOR_PALETTE[0] },
  ];

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsAreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />}
        <XAxis
          dataKey={xAxisKey}
          tick={{ fontSize: 11 }}
          tickLine={false}
          axisLine={{ stroke: '#e5e7eb' }}
        />
        <YAxis
          tick={{ fontSize: 11 }}
          tickLine={false}
          axisLine={false}
          width={40}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '6px',
            fontSize: '12px',
          }}
        />
        {showLegend && <Legend />}
        {chartSeries.map((s, index) => (
          <Area
            key={s.dataKey}
            type="monotone"
            dataKey={s.dataKey}
            name={s.name}
            stroke={s.color || CHART_COLOR_PALETTE[index % CHART_COLOR_PALETTE.length]}
            fill={s.color || CHART_COLOR_PALETTE[index % CHART_COLOR_PALETTE.length]}
            fillOpacity={fillOpacity}
            stackId={stacked ? 'stack' : undefined}
          />
        ))}
      </RechartsAreaChart>
    </ResponsiveContainer>
  );
}
